import * as v from 'valibot'
import type { UuidFormatType } from './common'
import ValibotCommon from './common'

export function getTODSchema(params: { expected_uuid_format: UuidFormatType; convert_uuid_format?: boolean }) {
	const { expected_uuid_format, convert_uuid_format = false } = params

	return v.object({
		id: ValibotCommon.getUuidSchema_V2({
			expected_format: expected_uuid_format,
			convert_format: convert_uuid_format,
			error_field_name: 'id',
		}),
		network_id: ValibotCommon.getUuidSchema_V2({
			expected_format: expected_uuid_format,
			convert_format: convert_uuid_format,
			error_field_name: 'network_id',
		}),
		name: ValibotCommon.getNonEmptyStringSchema({ error_field_name: 'name' }),
		local_start_time: v.pipe(v.string(), v.isoTimeSecond()),
		local_end_time: v.pipe(v.string(), v.isoTimeSecond()),
		has_monday: v.boolean(),
		has_tuesday: v.boolean(),
		has_wednesday: v.boolean(),
		has_thursday: v.boolean(),
		has_friday: v.boolean(),
		has_saturday: v.boolean(),
		has_sunday: v.boolean(),
		timezone_iana: v.pipe(v.string(), v.trim()),
		valid_range: v.pipe(v.string(), v.trim()),
	})
}
